import { configResponsive } from '@umijs/hooks'
import { MEDIA_QUERY } from '../../configs'

export { useResponsive } from '@umijs/hooks'

configResponsive(MEDIA_QUERY)
